import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, NgModule } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, first, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import * as i4 from 'dirty-check-store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import * as i2 from 'primeng/dynamicdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import * as i3 from '@ngrx/store';
import * as i5 from 'ngx-toastr';
import * as i7 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i8 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import * as i9 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i10 from 'primeng/checkbox';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';

class AddPrimaryContactService {
    constructor(http) {
        this.http = http;
        this.savePrimaryContactSubject = new BehaviorSubject({});
    }
    postContact(payload) {
        return this.http.post(`/companyContact/add`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
AddPrimaryContactService.ɵfac = function AddPrimaryContactService_Factory(t) { return new (t || AddPrimaryContactService)(i0.ɵɵinject(i1.HttpClient)); };
AddPrimaryContactService.ɵprov = i0.ɵɵdefineInjectable({ token: AddPrimaryContactService, factory: AddPrimaryContactService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddPrimaryContactService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function AddPrimaryContactComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "label", 28);
    i0.ɵɵtext(2, "Primary Contact Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-checkbox", 29);
    i0.ɵɵelementStart(4, "label", 30);
    i0.ɵɵtext(5, "Send Invite ");
    i0.ɵɵelementStart(6, "small");
    i0.ɵɵtext(7, "(Primary contact will be getting the invite link to login to Imagility)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddPrimaryContactComponent_div_17_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddPrimaryContactComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddPrimaryContactComponent_div_17_span_1_Template, 2, 1, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.addContactForm.get("firstName").errors == null ? null : ctx_r1.addContactForm.get("firstName").errors.required);
} }
function AddPrimaryContactComponent_div_22_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddPrimaryContactComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddPrimaryContactComponent_div_22_span_1_Template, 2, 1, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.addContactForm.get("lastName").errors == null ? null : ctx_r2.addContactForm.get("lastName").errors.required);
} }
function AddPrimaryContactComponent_div_31_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddPrimaryContactComponent_div_31_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.getGlobalErrorMessages("INVALID_EMAIL"), " ");
} }
function AddPrimaryContactComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddPrimaryContactComponent_div_31_span_1_Template, 2, 1, "span", 31);
    i0.ɵɵtemplate(2, AddPrimaryContactComponent_div_31_span_2_Template, 2, 1, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.userType !== "Attorney" && (ctx_r3.addContactForm.get("email").errors == null ? null : ctx_r3.addContactForm.get("email").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.addContactForm.get("email").errors == null ? null : ctx_r3.addContactForm.get("email").errors.pattern);
} }
function AddPrimaryContactComponent_div_32_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
function AddPrimaryContactComponent_div_32_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AddPrimaryContactComponent_div_32_div_4_span_1_Template, 2, 1, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.addContactForm.get("designation").errors == null ? null : ctx_r9.addContactForm.get("designation").errors.required);
} }
function AddPrimaryContactComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "label", 13);
    i0.ɵɵtext(2, " Designation ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 33);
    i0.ɵɵtemplate(4, AddPrimaryContactComponent_div_32_div_4_Template, 2, 1, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.addContactForm.get("designation").touched && ctx_r4.addContactForm.get("designation").invalid);
} }
class AddPrimaryContactComponent {
    constructor(fb, dynamicDialogRef, dynamicDialogConfig, store, guard, toast, apiService) {
        var _a;
        this.fb = fb;
        this.dynamicDialogRef = dynamicDialogRef;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.store = store;
        this.guard = guard;
        this.toast = toast;
        this.apiService = apiService;
        this.emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$';
        this.formChangesSubscriptions = [];
        this.onSaveComplete = new EventEmitter();
        this.destroy$ = new Subject();
        this.userType = sessionStorage.getItem('userTypeRole');
        this.inputData = this.dynamicDialogConfig.data;
        this.addContactForm = this.fb.group({
            id: [null],
            companyId: [this.inputData ? (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.companyId : null],
            isPetitionerAdmin: [true],
            isSendInvite: [this.userType === 'Attorney' ? false : true],
            firstName: [null, Validators.required],
            middleName: [null],
            lastName: [null, Validators.required],
            email: this.userType === 'Attorney' ? [null, Validators.pattern(this.emailPattern)] : [null, [Validators.required, Validators.pattern(this.emailPattern)]],
            designation: this.userType === 'Attorney' ? [null, Validators.required] : [null],
        });
    }
    ngOnInit() {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.formChangesSubscriptions[0] = this.addContactForm.valueChanges
            .subscribe(() => {
            if (this.addContactForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    handleClose() {
        this.guardSubscription = this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.dynamicDialogRef.close();
            }
            else {
                return false;
            }
        });
    }
    saveContact() {
        let payload = Object.assign({}, this.addContactForm.value);
        if (this.userType === 'Attorney') {
            payload.addUserForAttorneyLogin = true;
        }
        this.apiService.postContact(payload).pipe(takeUntil(this.destroy$)).subscribe((response) => {
            if (response) {
                this.toast.success(response.message, 'Success');
                this.apiService.savePrimaryContactSubject.next({ saved: true, data: response.data });
                this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
                this.dynamicDialogRef.close();
            }
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.formChangesSubscriptions) {
            this.formChangesSubscriptions.forEach(item => { item.unsubscribe(); });
        }
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
}
AddPrimaryContactComponent.ɵfac = function AddPrimaryContactComponent_Factory(t) { return new (t || AddPrimaryContactComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.DynamicDialogRef), i0.ɵɵdirectiveInject(i2.DynamicDialogConfig), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.DirtyFormGuard), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(AddPrimaryContactService)); };
AddPrimaryContactComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AddPrimaryContactComponent, selectors: [["lib-add-primary-contact"]], outputs: { onSaveComplete: "onSaveComplete" }, decls: 38, vars: 8, consts: [[1, "container-fuild"], [1, "p-grid", "pt-2"], [1, "p-col-7", "align-middle"], [1, "mb-0"], [1, "p-col-5", "text-right", "align-middle"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "mt-0", "mb-1"], [1, "p-col-12", "p-0"], [3, "formGroup"], [1, "main-body"], [1, "p-fluid", "p-formgrid", "p-grid", "pt-2"], ["class", "p-col-12 pb-3", 4, "ngIf"], [1, "p-col-4", "pb-3"], [1, "label-cls", "required"], ["id", "firstName", "formControlName", "firstName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100"], [4, "ngIf"], ["id", "lastName", "formControlName", "lastName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100"], [1, "label-cls"], ["id", "middleName", "formControlName", "middleName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100"], [3, "ngClass"], ["id", "email", "formControlName", "email", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100"], ["class", "p-col-4 pb-3", 4, "ngIf"], [1, "separator", "my-1"], [1, "p-0", "pt-2", "pb-2", "d-flex"], [1, "text-left", "m-0", "w-100"], ["pButton", "", "type", "button", "label", "SAVE", "title", "SELECT", 3, "disabled", "click"], ["pButton", "", "type", "button", "label", "CANCEL", "title", "CANCEL", 1, "p-button-secondary", "ml-3", 3, "click"], [1, "p-col-12", "pb-3"], [1, "create-task-for-label", "mr-4"], ["styleClass", "checkbox-label-allign", "name", "sendInvite", "formControlName", "isSendInvite", "binary", "true", 1, "align-middle"], [1, "checkBoxLabel", "mb-0", "pl-2"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], ["id", "designation", "formControlName", "designation", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100"]], template: function AddPrimaryContactComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5", 3);
        i0.ɵɵtext(4, "Add User");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "i", 5);
        i0.ɵɵlistener("click", function AddPrimaryContactComponent_Template_i_click_6_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "hr", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "form", 8);
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵtemplate(12, AddPrimaryContactComponent_div_12_Template, 8, 0, "div", 11);
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵelementStart(14, "label", 13);
        i0.ɵɵtext(15, " First Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "input", 14);
        i0.ɵɵtemplate(17, AddPrimaryContactComponent_div_17_Template, 2, 1, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 12);
        i0.ɵɵelementStart(19, "label", 13);
        i0.ɵɵtext(20, " Last Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(21, "input", 16);
        i0.ɵɵtemplate(22, AddPrimaryContactComponent_div_22_Template, 2, 1, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 12);
        i0.ɵɵelementStart(24, "label", 17);
        i0.ɵɵtext(25, " Middle Name (Optional) ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(26, "input", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 12);
        i0.ɵɵelementStart(28, "label", 19);
        i0.ɵɵtext(29, " Email ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(30, "input", 20);
        i0.ɵɵtemplate(31, AddPrimaryContactComponent_div_31_Template, 3, 2, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(32, AddPrimaryContactComponent_div_32_Template, 5, 1, "div", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(33, "hr", 22);
        i0.ɵɵelementStart(34, "div", 23);
        i0.ɵɵelementStart(35, "div", 24);
        i0.ɵɵelementStart(36, "button", 25);
        i0.ɵɵlistener("click", function AddPrimaryContactComponent_Template_button_click_36_listener() { return ctx.saveContact(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "button", 26);
        i0.ɵɵlistener("click", function AddPrimaryContactComponent_Template_button_click_37_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("formGroup", ctx.addContactForm);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.userType !== "Attorney");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.addContactForm.get("firstName").touched && ctx.addContactForm.get("firstName").invalid);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.addContactForm.get("lastName").touched && ctx.addContactForm.get("lastName").invalid);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngClass", ctx.userType === "Attorney" ? "label-cls" : "label-cls required");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.addContactForm.get("email").touched && ctx.addContactForm.get("email").invalid);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType == "Attorney");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", !ctx.addContactForm.valid);
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i7.NgIf, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlName, i8.InputText, i7.NgClass, i9.ButtonDirective, i10.Checkbox], styles: [".main-body[_ngcontent-%COMP%]{height:calc(65vh - 116px);width:100%;overflow:auto;padding-right:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddPrimaryContactComponent, [{
        type: Component,
        args: [{
                selector: 'lib-add-primary-contact',
                templateUrl: 'add-primary-contact.component.html',
                styleUrls: ['add-primary-contact.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.DynamicDialogRef }, { type: i2.DynamicDialogConfig }, { type: i3.Store }, { type: i4.DirtyFormGuard }, { type: i5.ToastrService }, { type: AddPrimaryContactService }]; }, { onSaveComplete: [{
            type: Output
        }] }); })();

class AddPrimaryContactModule {
}
AddPrimaryContactModule.ɵfac = function AddPrimaryContactModule_Factory(t) { return new (t || AddPrimaryContactModule)(); };
AddPrimaryContactModule.ɵmod = i0.ɵɵdefineNgModule({ type: AddPrimaryContactModule });
AddPrimaryContactModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            ButtonModule,
            DropdownModule,
            InputTextModule,
            CheckboxModule,
            DividerModule,
            DynamicDialogModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AddPrimaryContactModule, { declarations: [AddPrimaryContactComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        DropdownModule,
        InputTextModule,
        CheckboxModule,
        DividerModule,
        DynamicDialogModule], exports: [AddPrimaryContactComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddPrimaryContactModule, [{
        type: NgModule,
        args: [{
                declarations: [AddPrimaryContactComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    ButtonModule,
                    DropdownModule,
                    InputTextModule,
                    CheckboxModule,
                    DividerModule,
                    DynamicDialogModule
                ],
                exports: [AddPrimaryContactComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of add-primary-contact
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddPrimaryContactComponent, AddPrimaryContactModule, AddPrimaryContactService };
//# sourceMappingURL=add-primary-contact.js.map
